import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap'
import FeatherIcon from 'feather-icons-react';
import CusCard from '../containers/CusCardContainer'
import '../../node_modules/font-awesome/css/font-awesome.min.css'
import { Row } from 'react-bootstrap';
import CustomFooter from '../components/Footer';
import CustomHeader from '../components/Header'



class ManageSusTransSub extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (           
                <Row>
                    {/* <CusCard data1="Map Shell" data2="Cards & Vehicles" icon="credit-card" link="./ManageShellCard" ></CusCard>
                    <CusCard data1="Manage Vehicle" data2="Groups" icon="grid" link="./ManageVehicleGroups"></CusCard>
                    <CusCard data1="Set Profile" data2="Alert" icon="minimize-2" link="./UpdateUserProfile"></CusCard>*/}
                    <CusCard data1="Manage Suspicious" data2="Transactions Alerts" icon="minimize-2" link="./ManageSuspiciousTransaction"></CusCard> 
                    <CusCard data1="View Suspicious" data2="Transactions" icon="minimize-2" link="./ViewSuspTransSummary"></CusCard> 
                    
                    {/* <CusCard data1="Manage" data2="Safety" icon="truck" link="./ManageHSSE"></CusCard> */}
                    {/* <CusCard data1="Manage Vehicle" data2="Maintenance" icon="activity" link="./ManageVehicleHealth"></CusCard> */}
                    {/* <CusCard data1="Manual / Adjust " data2="Transactions" icon="edit" link="./ManualOrAdjustedTransaction"></CusCard> */}
                    {/* {<CusCard data1="Manual " data2="Transactions" icon="edit" link="./ManualOrAdjustedTransaction"></CusCard> */}
                    {/* <CusCard data1="Manage Declined" data2="Transactions" icon="slash" link="./ManageDeclinedTransaction"></CusCard> */}
                </Row>

        );
    }
}


export default ManageSusTransSub;